export const SCROLL_THRESHOLD = 200;

export const PAGES_WITH_SCROLL_BUTTON = [
    '/outfits',
    '/wardrobe',
    '/wardrobe/clothing',
];
